import { render, staticRenderFns } from "./NavbarConnectedLabel.vue?vue&type=template&id=0ed55da4&"
import script from "./NavbarConnectedLabel.vue?vue&type=script&lang=js&"
export * from "./NavbarConnectedLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports